module.exports = __webpack_public_path__ + "200df3c1c5001e0cc0c1770db70b7718.svg";